/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_400Inputs */

const en_api_error_400 = /** @type {(inputs: Api_Error_400Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid request parameters.`)
};

const pt_br2_api_error_400 = /** @type {(inputs: Api_Error_400Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parâmetros de requisição inválidos.`)
};

/**
* | output |
* | --- |
* | "Invalid request parameters." |
*
* @param {Api_Error_400Inputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_400 = /** @type {((inputs?: Api_Error_400Inputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_400Inputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_400(inputs)
	return pt_br2_api_error_400(inputs)
});